import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import 'ag-grid-enterprise';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import "./Library.css";
import { TopBar } from "../../shared/topBar/TopBar";
import { UrlPath } from "../../../config/routeConfig";
import {SBADropDown,SBAMultiSelect,SBAComboBox,SBAMultiSelectCheck,SBAMultiColumnComboBox,} from "../../UiComponents/SBADropDown";
import { DateRangePicker } from "rsuite";
import { SBAEditor } from '../../UiComponents/SBAEditor';
import { AgGridReact } from 'ag-grid-react';
import { sbaAxios } from "../../utils/sbaAxios";
import { useParams, useLocation } from "react-router-dom";
import { getActivityDetail, getCategory, getActivityEntityType, getActivityType } from "../../actions/investmentAction";
import { useDispatch, useSelector } from "react-redux";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { getManagerContacts } from "../../actions/CommonAction";
import { getSubStrategy } from "../../actions/assetDetailsActions";
import { getPortfolioListAction } from '../../actions/portfolioListAction'
import { getAllUsers } from "../../actions/UserAction";
import { getAssetLists } from "../../actions/assetListAction";
import { insertOrUpdateActivityDetails, insertOrUpdateActivityDocument, deleteActivity,DeleteDocument} from "../../../config/apiConfig";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import moment from "moment";
import { SBNotify } from "../../utils/sbNotify";
import { SBATextBox } from "../../UiComponents/SBATextBox";
import { Modal } from "react-bootstrap";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";

export const InvestmentEdit = () => {
  
    const params = useParams();
    const dispatch = useDispatch();
    const history = useNavigate();  
    const locationData = useLocation();
    const Gstate = useSelector((state) => state) || {};   
    const StrategyFillter = Gstate.subStrategy.subStrategy;
    const SubStrategy = StrategyFillter?.filter(item => item.ClassificationValue !== "--Please Select--")
    const managerFillter = Gstate.managerContacts.managerContacts;
    const manager = managerFillter?.filter(item => item.ManagerContact !== "--Please Select--")
    const users = useSelector((state) => state.Users.Users);
    const AssetListDDL = Gstate.assetList.assetList || [];  
    const ActivityDetailData = Gstate.activityDetail.activityDetail; 
    const activitySummary = ActivityDetailData?.ActivitySummary;
    const activityDocuments = ActivityDetailData?.ActivityDocuments;
    const [resulttrim, setResulttrim] = useState();
    const [selectedDocuments, setselectedDocuments] = useState();
    const activityref = ActivityDetailData?.ActivityXRefs;
    const [selectedEventDate, setselectedEventDate] = useState(null);
    const [isFlagEnabled,SetIsFlagEnabled]=useState(true);

    useEffect(()=>{
        dispatch(getActivityDetail(params.ActivityId,1));
        dispatch(getCategory(1));
        dispatch(getManagerContacts());
        dispatch(getSubStrategy());
        dispatch(getPortfolioListAction());
        dispatch(getAllUsers());
        dispatch(getAssetLists());
        dispatch(getActivityEntityType(1));
        dispatch(getActivityType());

    }, []);  
    
    const Categoryfilter = useSelector((state) => state.Category.Category) || [];
    const Category = Categoryfilter.filter(item => item.ActivitySubTypeId !== -1)
    const getPortfolioList = useSelector(state => state?.portfolioList?.portfolioList) || [];
    
    const ActivityTypefilter = useSelector((state) => state.ActivityType.ActivityType) || [];
    const ActivityType = ActivityTypefilter.filter(item => item.ActivityType !== "All")

    const [PartnerLetter, SetPartnerLetter] = useState(false);

    const [Entitytype, SetEntitytype] = useState();
    const [ExistingDocIds, SetExistingDocIds] = useState([]);
    
    const [assetDDLlist, setAssetDDLlist] = useState(AssetListDDL);
    const initialAssetId = activityref?.filter((item) => item.ActivityEntityTypeId === 1);

    const [assetId, SetAssetId] = useState();
    const initialmanager = activityref?.filter((item) => item.ActivityEntityTypeId === 2);
    const [managerId, SetmanagerId] = useState([]);

    const initialsubstrategy = activityref?.filter((item) => item.ActivityEntityTypeId === 13);
    const [SubStrategyId, SetSubStrategyId] = useState([]);

    const initialUsers = activityref?.filter((item) => item.ActivityEntityTypeId === 12);
    const [userId, SetuserId] = useState([]);

    const initialPortfolios = activityref?.filter((item) => item.ActivityEntityTypeId === 3);
    const [PortfolioId, SetPortfolioId] = useState([]);

    const [subject, setsubject] = useState(null);
    const [ActivitySubTypeIds, setActivitySubTypeIds] = useState();
  
    const [comments, setcomments] = useState();

    const [ManagerLetter, SetManagerLetter] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);

    const [saving,setSaving]=useState(false);
    const [fileError, setFileError] = useState("");

    const Level = [
        { BreadCrumb: "Investment >", Routes: `${UrlPath.DocumentsInvestment}` },
    ];
   

    useEffect(() => {
        setAssetDDLlist(AssetListDDL);
    
        setselectedDocuments(activityDocuments?.map((item) => ({
            DocumentId: item.DocumentId,
            DocumentName: item.DocumentName 
        })))
        if (initialsubstrategy) {
            const mappedSubStrategies = initialsubstrategy.map((item) => ({
                ClassificationId: item.EntityId,
                ClassificationValue: item.EntityName
            }));
            SetSubStrategyId(mappedSubStrategies);
        }
        if (initialAssetId) {
            const mappedasset = initialAssetId?.map((item) => ({
                AssetId: item.EntityId,
                AssetName: item.EntityName
            }));
            SetAssetId(mappedasset);
        }
        if (initialmanager) {
            const mappedmanager = initialmanager?.map((item) => ({
                ManagerContactId: item.EntityId,
                ManagerContact: item.EntityName
            }));
            SetmanagerId(mappedmanager);
        }
       
        if (initialUsers) {
            const mappedUsers = initialUsers.map((item) => ({
                UserId: item.EntityId,
                Fullname: item.EntityName
            }));
            SetuserId(mappedUsers);
        }
        if (initialPortfolios) {
            const mappedportfolio = initialPortfolios.map((item) => ({
                PortfolioId: item.EntityId,
                Name: item.EntityName
            }));
            SetPortfolioId(mappedportfolio);
        }
        setsubject(activitySummary?.ActivityName);
        setcomments(activitySummary?.ActivityDescriptionHtml);

        if (attach && attach.length > 0) {
            setActivitySubTypeIds({
                ActivitySubTypeId: attach[0]?.ActivitySubTypeId || '',
                ActivitySubType: attach[0]?.ActivitySubType || ''
            });
        }
        if (initialEntity && initialEntity.length > 0) {
            SetEntitytype({
                ActivityTypeId: initialEntity[0]?.ActivityTypeId || '',
                ActivityType: initialEntity[0]?.ActivityType || ''
            });
        }
        setselectedEventDate(activitySummary?.ActivityDate ? moment(activitySummary?.ActivityDate) : null);
       
        SetPartnerLetter(activityDocuments?.length>0?activityDocuments[0]?.IsPartnerLetter:false)
        SetManagerLetter(activityDocuments?.length>0?activityDocuments[0]?.IsManagerLetter:false)
        
       
    }, [Gstate]);


    const stateType = locationData.state !==null? locationData.state.Type === null ?"": locationData.state.Type:"";
    const stateNames = locationData.state !==null? locationData.state.Names === null ? "" : locationData.state.Names:"";
    const stateActivity = locationData.state !==null? locationData.state.Activity === null ?"" : locationData.state.Activity:"";
    const stateCategory = locationData.state !==null? locationData.state.Category === null ?"" : locationData.state.Category:"";
    const stateSubject = locationData.state !==null? locationData.state.Subject === null ?""  : locationData.state.Subject:"";
    const stateCreator = locationData.state !==null? locationData.state.Creator === null ?""  : locationData.state.Creator:"";
    const stateStartDate = locationData.state !== null ? locationData.state.StartDate === null ? "" : locationData.state.StartDate : "";
    const stateEndDate = locationData.state !== null ? locationData.state.EndDate === null ? "" : locationData.state.EndDate : "";
    useEffect(() => {
        if(selectedFiles?.length>0 || selectedDocuments?.length>0)
          SetIsFlagEnabled(false);
          else
          {
          SetIsFlagEnabled(true);
          SetManagerLetter(false);
          SetPartnerLetter(false);
          }
    },[selectedDocuments,selectedFiles])
    const attach = Category.filter(item => item.ActivitySubTypeId === activitySummary?.ActivitySubTypeId);
    const initialEntity = ActivityType.filter(item => item.ActivityTypeId === activitySummary?.ActivityTypeId);

    const commentsChange = (event) => {
        setcomments(event.html);
    }
    const TypeDDChange = (e) => {
        SetEntitytype({ ActivityTypeId: e.value.ActivityTypeId, ActivityType: e.value.ActivityType })
    }


    const managerDropdownChange = (e) => {
        SetmanagerId([...e.value]);
        
    };
    const subStrategyDropdownChange = (e) => {
        SetSubStrategyId([...e.value]);
       
    };
    const subjectChange = (event) => {
        
        setsubject(event.target.value);
        const result = SBATextBox(event.target.value)
        setResulttrim(result);
    }

    const CategoryDDChange = (e) => {
        
        setActivitySubTypeIds({ ActivitySubTypeId: e.value.ActivitySubTypeId, ActivitySubType: e.value.ActivitySubType })
    };


    const CreatoronChange = (e) => {
        SetuserId([...e.value]);
        
    }
    const PortfolioChanged = (e) => {
        SetPortfolioId([...e.value]);
    };
    const AssetDDChanged = (e) => {
        SetAssetId([...e.value]);
    };
    const gridValueFormatter = (params) => {
        return params.value;
    };
    const eventDateChange = (newDate) => {
        setselectedEventDate(newDate);
       
    }
    

    const DeleteButtonRenderer = (props) => {
        const handleDeleteClick = () => {
            if(props.data.DocumentId !=0)
            {
                SetExistingDocIds([...ExistingDocIds,props.data.DocumentId]);
                const updatedFiles = selectedDocuments.filter((item, index) => item.DocumentId !== props.data.DocumentId);
                setselectedDocuments(updatedFiles);
            }
            else
            {
                const updatedFiles = selectedDocuments.filter((item, index) => item.rowIndex !== props.data.rowIndex);
                setSelectedFiles(updatedFiles);
                setselectedDocuments(updatedFiles);
            }
            document.getElementById('fileInput').style.display = 'none';

         // Reset the file input value
        document.getElementById('fileInput').value = '';

        // Restore display
        document.getElementById('fileInput').style.display = 'block';
        }
         // Set display to none
        
        return (
            <div className="actions-cell">
                <i
                    className="fas fa-trash"
                    style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
                   onClick={handleDeleteClick}
                ></i>
            </div>
        );
    };

    const columnDefs = [
        {
            field: "DocumentName",
            headerName: "File Name",
            //cellRenderer: HyperlinkRenderer,
            sort: "asc",
            pinned: "left",
            width: 400,
            filter: "agTextColumnFilter",
            valueFormatter: gridValueFormatter,
            tooltipField: 'FileName'
        },
        {
            headerName: "",
            field: "Delete",
            maxWidth: 300,
            cellRenderer: DeleteButtonRenderer,
        }
    ];
    const cancelButtonClick = (e) => {
        history(`${UrlPath.DocumentsInvestment}`, {
            state:
            {
                Type: stateType,
                Names: stateNames, Activity: stateActivity, Category: stateCategory, Subject: stateSubject,
                Creator: stateCreator,
                StartDate: stateStartDate,
                EndDate: stateEndDate

            }
        });
    };
   
    const defaultColDef = {
        sortable: true, filter: true, floatingFilter: true, flex: 1,resizable:true
    }



    const deleteSelectedDetails = () => {
        sbaAxios({ url: `${deleteActivity}${params.ActivityId}` }).then(res => {
            SBNotify({
                Msg: "Selected Document Deleted Successfully", type: "success"          

            });
            setShowModal(false);
            setTimeout(() => {

                history(`${UrlPath.DocumentsInvestment}`,
                    {

                    });
            }, 1000);

        }).catch(error => {
            SBNotify({ Msg: error, type: "error" });
            setShowModal(false)
        })

    }



    const DeleteInvestment = () => {
        setShowModal(true);
    }


    const allowedExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'png', 'jpeg'];
    const handleFileChange = (event) => {
        const newFiles = event.target.files;
        if (newFiles.length > 0) {
            const updatedFiles = [...selectedFiles];
            const startingRowIndex = updatedFiles.length; 
        
            for (let i = 0; i < newFiles.length; i++) {
                const file = newFiles[i];
                const fileName = file.name;

                const lastDotIndex = fileName.lastIndexOf('.');
                const name = lastDotIndex >= 0 ? fileName.substring(0, lastDotIndex) : fileName;
                const extension = lastDotIndex >= 0 ? fileName.substring(lastDotIndex + 1) : '';
                // Check if the extension is allowed
                if (!allowedExtensions.includes(extension.toLowerCase())) {
                    setFileError(`Unsupported file format: .${extension}`);
                    continue; // Skip the rest if the format is invalid
                }
                setFileError("");

                const reader = new FileReader();

                reader.onload = function () {
                    if (reader.result) {
                        const arrayBuffer = reader.result;
                        const base64String = arrayBufferToBase64(arrayBuffer);
                        const rowIndex = startingRowIndex + i;   
                        updatedFiles.push({ file, fileName, extension, base64String,rowIndex });
                        setselectedDocuments([...selectedDocuments, { DocumentId: 0, DocumentName: fileName,rowIndex}]);
                        setSelectedFiles(updatedFiles);
                       
                    }
                };


                reader.readAsArrayBuffer(file);
            }

           
        }
    };

    const arrayBufferToBase64 = (arrayBuffer) => {
        const binary = [];
        const bytes = new Uint8Array(arrayBuffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary.push(String.fromCharCode(bytes[i]));
        }
        return btoa(binary.join(''));
    };
    const Documentdetails = (activityid) => {
        const DocumentData = selectedFiles.map((obj) => ({
            ActivityId: activityid,
            DocumentId: 0,
            DocumentName: obj.fileName,
            DocumentContent: obj.base64String,
            DocumentExtension: "."+obj.extension,
            DocumentDate: selectedEventDate,
            RuleId: 0,
            IsPartnerLetter: PartnerLetter,
            IsEmailForwarded: false,
            IsReturnsProcessed: false,
            IsManagerLetter: ManagerLetter,
            ModifiedBy: 0,
            ActivitySourceId: 1
        }));

        sbaAxios({
            url: `${insertOrUpdateActivityDocument}`,
            method: "post",
            data: DocumentData,
        }).then((response) => {
          
        })

            .catch((error) => {
                console.error(error);
            });

    }

 
    const DeleteDocuments=()=>
    {
      ExistingDocIds.forEach((item) => {
          sbaAxios({
            url: `${DeleteDocument}${params.ActivityId},${item}`
          })
            .then((res) => {
              setSelectedFiles(selectedFiles.filter((items, index) => items.DocumentId !== item))
            })
            .catch((error) => {
              SBNotify({ Msg: error, type: "error" });
            });
        });
    }
    const saveInvestment = (event) => {
        let saveSuccess = true;
        setSaving(true);
        event.preventDefault();
        const activityXRefs = [];
        if (assetId.length > 0) {
            activityXRefs.push(
                ...assetId.map((asset) => ({
                    activityXRefId: 0,
                    activityId: 0,
                    activityEntityTypeId: 1,
                    activityEntityType: "Asset",
                    entityId: asset.AssetId,
                    entityName: asset.AssetName,
                }))
            );
        }

        if (managerId.length > 0) {
            activityXRefs.push(
                ...managerId.map((manager) => ({
                    activityXRefId: 0,
                    activityId: 0,
                    activityEntityTypeId: 2,
                    activityEntityType: "Manager",
                    entityId: manager.ManagerContactId,
                    entityName: manager.ManagerContact,
                }))
            );
        }

        if (userId.length > 0) {
            activityXRefs.push(
                ...userId.map((user) => ({
                    activityXRefId: 0,
                    activityId: 0,
                    activityEntityTypeId: 12,
                    activityEntityType: "User",
                    entityId: user.UserId,
                    entityName: user.Fullname,
                }))
            );
        }

        if (SubStrategyId.length > 0) {
            activityXRefs.push(
                ...SubStrategyId.map((SubStrategy) => ({
                    activityXRefId: 0,
                    activityId: 0,
                    activityEntityTypeId: 13,
                    activityEntityType: "SubStrategy",
                    entityId: SubStrategy.ClassificationId,
                    entityName: SubStrategy.ClassificationValue,
                }))
            );
        }

        if (PortfolioId.length > 0) {
            activityXRefs.push(
                ...PortfolioId.map((Portfolio) => ({
                    activityXRefId: 0,
                    activityId: 0,
                    activityEntityTypeId: 3,
                    activityEntityType: "Portfolio",
                    entityId: Portfolio.PortfolioId,
                    entityName: Portfolio.Name,
                }))
            );
        }
       
        const data = {
            "activitySummary": {
                "activityId": params.ActivityId,
                "activityTypeId": Entitytype.ActivityTypeId,
                "activitySubTypeId": ActivitySubTypeIds.ActivitySubTypeId,
                "activityName": subject,
                "activityDescription": comments ? comments.replace(/<\/?[^>]+(>|$)/g, ""):null,
                "activityDescriptionHtml": comments ? comments : null,
                "activityDate": selectedEventDate,
                "activitySourceId": 1
            },
            "activityDetails":
            {
               
                "activityDetailId": ActivityDetailData.ActivityDetails.ActivityDetailId,
                "activityId": params.ActivityId,
                "emailMessageId": "",
                "emailFrom": "",
                "emailTo": "",
                "mailCc": "",
                "emailSubject": "",
                "emailBody": "",
                "emailBodyHtml": "",
                "emailDate": selectedEventDate,
                "meetingDate": selectedEventDate,
                "IsPartnerLetter": PartnerLetter,
                "IsManagerLetter": ManagerLetter
            },
            "activityXRefs": activityXRefs,
            "modifiedBy": 0,
        };
      
        if (!Entitytype.ActivityType) {
            SBNotify({ Msg: "Please Select Activity Type", type: "error" });
            saveSuccess = false;
            setSaving(false);
        }
        else if (!ActivitySubTypeIds.ActivitySubTypeId || ActivitySubTypeIds.ActivitySubTypeId === -1) {
            SBNotify({ Msg: "Please Select Category Type", type: "error" });
            saveSuccess = false;
            setSaving(false);

        }
        else if ((resulttrim == false) || (!subject) || (subject == "   ")) {
            SBNotify({ Msg: "Subject is Required", type: "error" });
            saveSuccess = false;
            setSaving(false);
        }
        else if (assetId.length < 1) {
            SBNotify({ Msg: "Please Select Asset", type: "error" });
            saveSuccess = false;
            setSaving(false);

        }
        if(ExistingDocIds.length >0)
        {
            DeleteDocuments();
        }
        //if (selectedFiles.length === 0 && activityDocuments.length===0) {
        //    SBNotify({ Msg: "Please Upload files", type: "warning" });
        //    saveSuccess = false;
        //}
        if (saveSuccess) {
           
            sbaAxios({
                url: `${insertOrUpdateActivityDetails}`,
                method: "post",
                data: data,
            })
                .then((response) => {
               setSaving(false);
                    if (response > 0) {
                        if(selectedFiles.length > 0)
                        {
                        Documentdetails(params.ActivityId);
                        }
                    }
                    setTimeout(() => {
                    toast.success("Investment Updated Successfully", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }, 500);
                        history(`${UrlPath.DocumentsInvestment}`, {
                            state:
                            {
                                Type: stateType,
                                Names: stateNames,
                                Activity: stateActivity,
                                Category: stateCategory,
                                Subject: stateSubject,
                                Creator: stateCreator,
                                StartDate: stateStartDate,
                                EndDate: stateEndDate
                            }
                        });
                 
                })
                .catch((error) => {
                    setSaving(false);
                    console.error(error);
                });
        };
    }
    
        
    return <>{saving ? <><LoadingScreen/></> :
        <>
            <div>

                <TopBar label={"Investment Edit"} />
                <BreadCrumbs Levels={Level} />
                <div className="container-fluid">
                    <div>
                        <div className="d-flex justify-content-end gap-2">
                            <button type="submit" className="s-sm-btn me-1" onClick={cancelButtonClick} > Cancel</button>
                            <button type="submit" className="p-sm-btn mx-1" disabled={saving} onClick={saveInvestment}> Save </button>
                            {/*<button type="submit" className="p-sm-btn mx-1" > Save & Email</button> */}
                            <button type="submit" className="p-sm-btn mx-1" onClick={DeleteInvestment}> Delete</button>

                        </div>
                        <br />
                        <div>
                            <div id="content" class="asset-detail-screen mainContentData">
                                <div className="row-md-12 d-flex gap-1">
                                    <div className="col-md-6">

                                        <div class="row detail p-3  m-0">

                                            <div className="row">

                                                <div className="col-md-4">
                                                    <label
                                                        for="select fund"
                                                        className="mb-1 ms-2 fw-semibold fs-12"
                                                    >
                                                        Activity Type <span className="mandatory">*</span>
                                                    </label>
                                                    <div>
                                                        <SBADropDown
                                                            className="w-85"
                                                            data={ActivityType}
                                                            value={Entitytype}
                                                            valueField="ActivityTypeId"
                                                            textField="ActivityType"
                                                            onChange={TypeDDChange}
                                                            filterable={true}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label
                                                        for="select fund"
                                                        className="mb-1 ms-2 fw-semibold fs-12"
                                                    >
                                                        Category <span className="mandatory">*</span>
                                                    </label>
                                                    <div>

                                                        <SBADropDown
                                                            className="w-85"
                                                            textField={"ActivitySubType"}
                                                            valueField={"ActivitySubTypeId"}
                                                            data={Category}
                                                            value={ActivitySubTypeIds}
                                                            onChange={CategoryDDChange}
                                                            filterable={true}
                                                        />
                                                    </div>

                                                </div>
                                                <div className="col-md-4">
                                                    <label
                                                        for="select fund"
                                                        className="mb-1 ms-2 fw-semibold fs-12"
                                                    >
                                                        Event Date
                                                    </label>
                                                   <div>
                                                    <SBDatePicker className="w-75" id="eventDate"
                                                        value={moment(selectedEventDate)}
                                                        onChange={eventDateChange}>
                                                    </SBDatePicker>

                                                   </div>

                                                </div>


                                            </div>
                                            <div className="row" style={{ marginTop: "20px" }}>
                                                <div className="col-md-6">
                                                    <label
                                                        for="select fund"
                                                        className="mb-1 ms-2 fs-12 fw-semibold"
                                                    >
                                                        Subject <span className="mandatory">*</span>
                                                    </label>
                                                    <input
                                                        className="w-125 input-default form-control"
                                                        type="text"
                                                        placeholder="Type here"
                                                        onChange={subjectChange}
                                                        Value={subject}

                                                    //onKeyUp={loadOnEnter}
                                                    />

                                                </div>
                                                <div className="col-md-3">
                                                    <label></label>
                                                    <label style={{ display: 'flex', alignItems: 'center' }}>
                                                        <input className="me-1"
                                                            type="checkbox"
                                                            disabled={isFlagEnabled}
                                                            checked={PartnerLetter}
                                                            onChange={(e) => { SetPartnerLetter(value => !value) }}
                                                        />
                                                        <span >Partner Letter</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-3">
                                                    <label></label>
                                                    <label style={{ display: 'flex', alignItems: 'center' }}>
                                                        <input className="me-1"
                                                            type="checkbox"
                                                            disabled={isFlagEnabled}
                                                            checked={ManagerLetter}
                                                            onChange={(e) => { SetManagerLetter(value => !value) }}
                                                        />
                                                        <span >Manager Letter</span>
                                                    </label>
                                                </div>

                                            </div>
                                            <div className="row" style={{ marginTop: "10px" }}>
                                                <label
                                                    for="select fund"
                                                    className="mb-1 ms-2 fs-12 fw-semibold">
                                                    Description:
                                                </label>
                                                <SBAEditor id="editor" onChange={commentsChange} defaultContent={comments} editorHeight={300} setContent={setcomments}  ></SBAEditor>
                                            </div>
                                            <div className="row" style={{ marginTop: "10px" }}>
                                                <div>
                                                    <label
                                                        for="select fund"
                                                        className="mb-1 ms-2 fs-12 fw-semibold"
                                                    >
                                                        Tags:
                                                    </label>
                                                    <input
                                                        className="w-400 input-default form-control"
                                                        type="text"

                                                        onChange={subjectChange}
                                                        value={''}
                                                        //onKeyUp={loadOnEnter}
                                                        style={{ height: '60px' }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row" style={{ marginTop: "10px" }}>
                                                <div style={{ position: "relative" }}>
                                                    <input
                                                        type="file"
                                                        id="fileInput"
                                                        className="input-hidden"
                                                        onChange={handleFileChange}
                                                    />
                                                    {fileError && <p style={{ color: 'red' }}>{fileError}</p>}
                                                </div>
                                            </div>

                                            <div className="row" style={{ marginTop: "10px" }}>
                                                <div className="ag-theme-alpine" style={{ width: '100%', height: '200px' }}>
                                                    <AgGridReact
                                                        columnDefs={columnDefs}
                                                        rowData={selectedDocuments}
                                                        defaultColDef={defaultColDef}
                                                    >
                                                    </AgGridReact>
                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                    <div className="col-md-6">

                                        <div class="row detail p-3 m-0">

                                            <div className="row">

                                                <div className="col-md-12">
                                                    <label className="mb-1 ms-2 fw-semibold fs-12">
                                                        Manager
                                                    </label>
                                                    <div className="col-lg-12 mb-4">
                                                        <SBAMultiSelectCheck
                                                            className="w-75"
                                                            data={manager}
                                                            dataItemKey={"ManagerContactId"}
                                                            textField={"ManagerContact"}
                                                            onChange={managerDropdownChange}
                                                            value={managerId}
                                                            tags={
                                                                managerId?.length > 0
                                                                    ? [
                                                                        {
                                                                            text: `${managerId.length} items selected`,
                                                                            data: [...managerId],
                                                                        },
                                                                    ]
                                                                    : []
                                                            }
                                                            filterable={true}
                                                        />
                                                    </div>


                                                </div>
                                            </div>

                                            <div className="row" >

                                                <div className="col-md-12">
                                                    <label
                                                        for="select fund"
                                                        className="mb-1 ms-2 fw-semibold fs-12"
                                                    >
                                                        Asset
                                                    </label>
                                                    <div className="col-lg-12 mb-4">
                                                        <SBAMultiSelectCheck
                                                            data={assetDDLlist}
                                                            dataItemKey="AssetId"
                                                            textField="AssetName"
                                                            className="w-75"
                                                            onChange={AssetDDChanged}
                                                            value={assetId}
                                                            tags={
                                                                assetId?.length > 0
                                                                    ? [
                                                                        {
                                                                            text: `${assetId.length} items selected`,
                                                                            data: [...assetId],
                                                                        },
                                                                    ]
                                                                    : []
                                                            }
                                                            filterable={true}
                                                        ></SBAMultiSelectCheck>
                                                    </div>


                                                </div>
                                            </div>

                                            <div className="row gap-3">

                                                <div className="col-md-12">
                                                    <label
                                                        for="select fund"
                                                        className="mb-1 ms-2 fw-semibold fs-12"
                                                    >
                                                        Strategy
                                                    </label>
                                                    <div className="col-lg-12 mb-4">
                                                        <SBAMultiSelectCheck
                                                            className="w-75"
                                                            data={SubStrategy}
                                                            value={SubStrategyId}
                                                            tags={
                                                                SubStrategyId?.length > 0
                                                                    ? [
                                                                        {
                                                                            text: `${SubStrategyId.length} items selected`,
                                                                            data: [...SubStrategyId],
                                                                        },
                                                                    ]
                                                                    : []
                                                            }
                                                            textField={"ClassificationValue"}
                                                            dataItemKey={"ClassificationId"}
                                                            onChange={subStrategyDropdownChange}
                                                            filterable={true}

                                                        />

                                                    </div>


                                                </div>
                                            </div>
                                            <div className="row gap-3">

                                                <div className="col-md-12">
                                                    <label
                                                        for="select fund"
                                                        className="mb-1 ms-2 fw-semibold fs-12"
                                                    >
                                                        Contributor
                                                    </label>
                                                    <div className="col-lg-12 mb-4">
                                                        <SBAMultiSelectCheck
                                                            className="w-75"
                                                            data={users}
                                                            value={userId}
                                                            tags={
                                                                userId?.length > 0
                                                                    ? [
                                                                        {
                                                                            text: `${userId.length} items selected`,
                                                                            data: [...userId],
                                                                        },
                                                                    ]
                                                                    : []
                                                            }
                                                            dataItemKey="UserId"
                                                            textField="Fullname"
                                                            onChange={CreatoronChange}
                                                            filterable={true}

                                                        />

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row gap-3">

                                                <div className="col-md-12">
                                                    <label
                                                        for="select fund"
                                                        className="mb-1 ms-2 fw-semibold fs-12"
                                                    >
                                                        Portfolio
                                                    </label>
                                                    <div className="col-lg-12 mb-4">
                                                        <SBAMultiSelectCheck
                                                            className="w-75"
                                                            data={getPortfolioList}
                                                            value={PortfolioId}
                                                            tags={
                                                                PortfolioId?.length > 0
                                                                    ? [
                                                                        {
                                                                            text: `${PortfolioId.length} items selected`,
                                                                            data: [...PortfolioId],
                                                                        },
                                                                    ]
                                                                    : []
                                                            }
                                                            dataItemKey="PortfolioId"
                                                            textField="Name"
                                                            onChange={PortfolioChanged}
                                                            filterable={true}

                                                        />

                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={showModal}  >
                <Modal.Header closeButton onClick={() => { setShowModal(false) }}>
                    <Modal.Title>Do you want to delete the selected Document?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Document will be deleted permanently. Are you sure?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button className="s-sm-btn mx-1" onClick={() => { setShowModal(false) }}>Cancel</button>
                    <button className='p-sm-btn mx-1' onClick={() => { deleteSelectedDetails() }} >
                        Yes
                    </button>
                </Modal.Footer>
            </Modal>
            <ToastContainer></ToastContainer>
        </>
    }</>
};
